import { Button } from "react-bootstrap";
import "@/styles/components/gitcha-not-available-modal.css";
import Modal from "react-bootstrap/Modal";

const ActiveBuyerReportComingSoonModal = (props) => {
  const { show, onHide } = props;

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName="modal-wrapper"
      backdrop="static"
    >
      <Modal.Body className="modal-body">
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onHide}
        />

        <div className="content-container">
          <h3 className="content-title-text">
            Demand Report is coming soon
          </h3>
          <p className="fs-6 content-description-text mt-3">
            We're putting the finishing touches on the Demand Report: a
            shareable, seller-facing breakdown of real buyer demand for this
            property.
          </p>
          <p className="fs-6 content-description-text mt-3">
            You'll be able to generate and download it right from this panel.
            We'll let you know the moment it's live.
          </p>
        </div>

        <div className="modal-footer mt-20 p-0 d-flex justify-content-end">
          <Button variant="primary" onClick={onHide}>
            OK
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ActiveBuyerReportComingSoonModal;
